// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__25hZt","error":"Textarea_error__28SUd","readonly":"Textarea_readonly__2FhB3","disabled":"Textarea_disabled__2S_Wr"};